import Nullstack from 'nullstack';
export default function IconAsteriskSimple({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-asterisk-simple",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v-9"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l-9 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l9 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l6 8.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 12l-6 8.5"
  }), " ");
}